import {useContext} from "react";
import GlobalContext from "../context/GlobalContext";
import { HiPlusCircle } from "react-icons/hi";

export default function CreateEventButton(){

    const {setShowEventModal}=useContext(GlobalContext)
    return(
        <HiPlusCircle 
        // className="border p-2 rounded-full flex items-center shadow-md hover:shadow-2" 
        className="button hover:bg-green-700 bg-green-600  rounded-full cursor-pointer "  
        onClick={()=>setShowEventModal(true)}
        style={
                {
                    marginTop: "10px", 
                    // backgroundColor: "#15803d", 
                    width: "5rem", 
                    height: "2rem", 
                    // borderRadius: "4px", 
                    color: "white", 
                    textAlign:"center",
                    opacity: 0.9, 
                    // backgroundColorHover: "#14532d"
                }
            }
            />
            
            //    <img src={plus} alt="create_event" className="w-7 h-7"/>
            // <span className="pl-3 pr-7 font-bold bg-red-700 "> Create New Event</span>
            // </button>
            );
        }